import { GenerateOtterSubscriptionEntitiesError } from '@otter-ai/recall-client';

export function isMissingStripeIdError(
  error: GenerateOtterSubscriptionEntitiesError,
) {
  return (
    error &&
    typeof error === 'object' &&
    error.message?.includes('missing Stripe subscription ID') &&
    error.code === 25
  );
}

export function handleMissingStripeIdError(
  error: GenerateOtterSubscriptionEntitiesError,
) {
  console.warn(
    'generateOtterEntities failed with error: ',
    error.message,
    'Continuing with purchase confirmation.',
  );
}
